import { cva } from '@/styled-system/css';

export const dateTimeBlockWrapRecipe = cva({
  base: {
    '&:first-child': {
      marginBlockEnd: 'tightest',
    },
    '&:last-child:not(:first-child)': {
      marginBlockStart: 'tight',
    },
  },
  variants: {
    includeOffset: {
      true: {
        paddingInline: 'calc({spacing.looser} + {spacing.DateTimeBlock.Wrap.padding.horz.inner})',
      },
    },
  },
});
